import { useMutation, useQueryClient } from '@tanstack/react-query';

import { IGlobalNotification } from '@/interfaces/entities/global-notification';
import { globalNotificationService } from '@/services/global_notification.service';

const useCreateGlobalNotificaiton = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (notification: IGlobalNotification) =>
			await globalNotificationService.newGlobalNotification(notification),

		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['global-notification'] });
		},

		onError: () => {
			throw new Error('Error creating global notification');
		},
	});
};

export default useCreateGlobalNotificaiton;
